import { useContext } from 'react'
import { observer } from 'mobx-react'
import { Title, ListTable, ListPropsContext } from 'src/components'
import { listStore } from 'src/stores'

const ListPageTable = () => {
  const listProps = useContext(ListPropsContext)
  const table = listStore.table.get(listProps.formCode)

  return (
    <div className='list-page__table'>
      <Title title={table?.tableConfig?.Nav_Form?.NAME || '基础表格'} className='mg-b12' />
      <div className='list-page__table-zone'>
        <ListTable
          checkboxEnable
          formCode={listProps.formCode}
          {...listProps.formData?.listTable}
        />
      </div>
    </div>
  )
}

export default observer(ListPageTable)